import { CanLoad, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";

import { AuthService } from "../services/auth.service";

import { Observable } from 'rxjs';

@Injectable()
export class AuthGuard implements CanLoad {

  constructor(private authService: AuthService) { }

  /*
   * Método responsável por liberar o carregamento do módulo
   */
  public canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkAuthenticate(route.path);
  }

  /*
   * Método responsável por checar se o usuário estar autenticado
   */
  private checkAuthenticate(path: string): boolean {
    const isAuthenticated: boolean = this.authService.isAuthenticated();
        
    if (!isAuthenticated) {
      sessionStorage.clear();
      this.authService.handleLogin();
    }

    return isAuthenticated;
  }
}
